export default __webpack_public_path__ + "static/media/left-arrow-blue-icon.54dabc7a.svg";